<template>
<div>
  <NavBar/>
  

  <img v-if="!isMobile()" class="homepage" src="../assets/pages/homePage.jpg" alt="" usemap="#image-map2">

  <map name="image-map2" v-if="!isMobile()">
    <area target="_blank" alt="genesis" title="genesis" href="https://opensea.io/collection/cosmiclabs" coords="457,1438,817,1801" shape="rect">
    <area target="_blank" alt="mutant" title="mutant" href="https://opensea.io/collection/cosmic-mutants" coords="1103,1438,1468,1798" shape="rect">
    <area target="" alt="babies"  title="babies" href="https://opensea.io/collection/cosmic-babies" coords="226,2492,562,2832" shape="rect">
    <area target="" alt="fusion"  title="fusion" href="https://opensea.io/collection/cosmicfusions" coords="791,2492,1132,2829" shape="rect">
  </map>

  <img v-if="isMobile()" class="homepage" src="../assets/mobile/home.jpg" alt="" usemap="#image-map">
  <map name="image-map" v-if="isMobile()">
    <area target="" @click="FuseBreed()" alt="clabs" title="clabs" coords="340,1411,734,1810" shape="rect">
  </map>
  <Footer/>
</div>
</template>

<script>
import NavBar from './Navigation/NavBar.vue'
import Footer from './Navigation/Footer.vue'
export default {
  components:{
    NavBar,
    Footer
  },
  created() {
    window.location.href = "https://chimbastudios.com/cosmic-labs"; // Replace with your desired URL
  },
  mounted()
  {
    $(document).ready(function(e) {
      $('img[usemap]').rwdImageMaps();
    });
  },
  methods:{
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          return true
      } else {
          return false
      }
    },
    FuseBreed()
    {
        this.$router.push({ name: 'FuseBreed' })
    }
  }
  
}
</script>

<style scoped>
.homepage
{
  width: 100%;
  z-index: -1;

}
</style>


// WEBPACK FOOTER //
// src/components/Home.vue